var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19032 3L2.6946 4.49581C2.20868 4.65749 1.9194 5.15507 2.01985 5.65645L2.634 8.72179C2.7538 9.31976 3.3715 9.6776 3.95103 9.48477L5.90641 8.83411V19.9862C5.90641 20.5461 6.36111 21 6.92201 21H8.16836L8.21399 20.8168C9.78053 14.5259 8.88947 8.84128 8.21175 5.96705L8.08878 5.44551C7.58008 4.74233 7.26006 3.90091 7.19032 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98974 7.00457C10.6028 10.218 11.1043 15.3586 9.73755 21H14.2625C12.8957 15.3586 13.3972 10.218 14.0103 7.00457C13.7436 7.12649 13.4628 7.22538 13.17 7.29844C12.4018 7.49015 11.5982 7.49015 10.83 7.29844C10.5372 7.22538 10.2564 7.12649 9.98974 7.00457Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.078 21H15.8087C15.8086 20.9395 15.8013 20.8781 15.786 20.8168C14.2195 14.5259 15.1105 8.84128 15.7882 5.96705L15.9112 5.44551C16.4199 4.74233 16.7399 3.90091 16.8097 3L21.3054 4.49581C21.7913 4.65749 22.0806 5.15507 21.9801 5.65645L21.366 8.72179C21.2462 9.31976 20.6285 9.6776 20.049 9.48477L18.0936 8.83411V19.9862C18.0936 20.5461 17.6389 21 17.078 21Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2781 3.01348C13.1387 3.64447 10.8615 3.64447 8.72205 3.01348C8.8807 4.35905 9.85707 5.48808 11.1996 5.82311C11.7252 5.95428 12.275 5.95428 12.8006 5.82311C14.1431 5.48808 15.1195 4.35905 15.2781 3.01348Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt2);
export default __webpack_public_path__ + "static/media/shirt-2.283446a01de14b337d6ab06e105def98.svg";
export { ForwardRef as ReactComponent };